export default __webpack_public_path__ + "static/media/product-woman.57fa3095.png";